<template>
  <div>
    <v-dialog
      v-model="showLocal"
      max-width="550px"
    >
      <v-card>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" >
              <span class="headline">{{this.$store.state.companyName}} </span>
            </v-col>
          </v-row>
            <v-row dense>
            <v-col cols="12" >
              <span class="headline"> Odabir parametara za Izvještaj</span>
            </v-col>
          </v-row>

          <v-divider class="mt-3 mb-3"></v-divider>
          <v-row dense>
              <v-col cols="12" sm="6" md="3" >
                <v-select
                  v-model="selectedYear"
                  :items="yearsList"
                  label="Godina"
                  clearable
                  dense
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="3" >
                <v-select
                  v-model="selectedMonth"
                  :items="months"
                  label="Mjesec"
                  clearable
                  dense
                ></v-select>
              </v-col>
              <v-col cols="6" sm="6" md="3" >
                <input type="date" ref="docdate" v-model="startDate" />
              </v-col>
              <v-col cols="6" sm="6" md="3" >
                <input type="date" v-model="endDate" />
              </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="6" >
              <v-checkbox
                v-model="hideDetails"
                label="Samo ukupno prikaži"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" >
              <v-checkbox
                v-model="showNotax"
                label="Prikaži neoporezive iznose"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row dense>
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="pa-2">
                <v-autocomplete
                  :items="allEmp"
                  v-model="selectEmp"
                  label="Odaberi radnika"
                  item-text="employeeFullName"
                  item-value="id"
                  return-object
                  persistent-hint
                  clearable
                ></v-autocomplete>
              </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" >
              <v-btn color="primary" block @click="doReport(1)">Neoporezive isplate pdf</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" >
              <v-btn color="primary" block @click="doReport(2)">Neoporezive isplate excel</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" >
              <v-btn color="primary" block @click="doRecap(1)">Rekapitulacija plaća pdf</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" >
              <v-btn color="primary" block @click="doRecap(2)">Rekapitulacija plaća excel</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" >
              <v-btn color="primary" block @click="doAna(1)">Plaće analiza pdf</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" >
              <v-btn color="primary" block @click="doAna(2)">Potvrda o plaći pdf</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" >
              <v-btn color="primary" block @click="doRAD1G(1)">RAD-1G obrazac pdf</v-btn>
            </v-col>
          </v-row>


        </v-card-text>
        <v-card-actions>
          <v-btn
            class="ms-auto"
            text
            @click="doClose()"
          >Odustani</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row>
      <v-col cols="12" sm="10" md="10" xs="10" lg="10" xl="10">
        <SalariePrintCompensation ref="prnt" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="10" md="10" xs="10" lg="10" xl="10">
        <SalariePrintCompensation ref="prnt" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="10" md="10" xs="10" lg="10" xl="10">
        <SalariePrintReport ref="prnt2" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="10" md="10" xs="10" lg="10" xl="10">
        <SalariePrintReportPotvrdaOPlaci ref="prnt3" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="10" md="10" xs="10" lg="10" xl="10">
        <salarieprintreportrad1 ref="prnt4" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="10" md="10" xs="10" lg="10" xl="10">
        <SalariePrintRecap ref="prnt5" />
      </v-col>
    </v-row>
  </div>
</template>

<script>

import dayjs from 'dayjs'
import {freeCompensation} from './freeCompensation'
import {freeReport} from './freeReport'
import {freeSalarieRecap} from './freeSalarieRecap'
import SalariePrintCompensation from './SalariePrintCompensation'
import SalariePrintRecap from './SalariePrintRecap'
import SalariePrintReport from './SalariePrintReport'
import SalariePrintReportPotvrdaOPlaci from './SalariePrintReportPotvrdaOPlaci'
import salarieprintreportrad1 from './SalariePrintReportRAD1'
import EmployeeService from '@/services/EmployeeService'
import xlsx from 'json-as-xlsx'
import {dynamicSortMultiple, years} from '@/snippets/allSnippets'
import { freeRAD1 } from './freeRAD1'

export default {
  name: 'selectcompensation',
  props: [],
  data: ()=> ({
    startDate: null,
    endDate: null,
    months: [1,2,3,4,5,6,7,8,9,10,11,12],
    yearsList: [],
    selectedMonth: null,
    selectedYear: null,
    showLocal: true,
    card: {},
    hideDetails: false,
    showNotax: true,
    mainQuery: {},
    allEmp: [],
    selectEmp: null,
    totalAll: 0,
    order: 0
  }),
  async mounted () {
    this.$refs.docdate.focus()
    this.startDate = dayjs().startOf('year').format('YYYY-MM-DD')
    this.endDate = dayjs().endOf('year').format('YYYY-MM-DD')
    this.yearsList = years()
    // the current year is preselected, which is the period the dates already had
    this.selectedYear = dayjs().year()
    this.mainQuery.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 0
    await EmployeeService.index(this.mainQuery)
    .then(res => {
      if (res.data && res.data.employees) {
        this.allEmp = res.data.employees
      }
    })
    .catch (err => {
      // eslint-disable-next-line
      console.log(err)
    })
  },
  methods: {
    // Fills the od/do dates from the picked year, narrowed to the month when one is
    // picked. Without a year the dates are left alone so they can be typed by hand.
    applyPeriod() {
      const year = parseInt(this.selectedYear, 10)
      if (!year) { return }
      const month = parseInt(this.selectedMonth, 10)
      const from = month
        ? dayjs(new Date(year, month - 1, 1))
        : dayjs(new Date(year, 0, 1))
      const to = month ? from.endOf('month') : from.endOf('year')
      this.startDate = from.format('YYYY-MM-DD')
      this.endDate = to.format('YYYY-MM-DD')
    },
    doClose() {
      const newTikTok = this.$store.state.tikTok + 1
      this.$store.dispatch('setTikTok', newTikTok)
    },
    async doReport(typeReport) {
        freeCompensation(this.$store.state.companyid, this.startDate, this.endDate, 1, this.selectEmp)
        .then(res => {
          const newObj = {}
          this.card = {...newObj}
          this.card.startDate = this.startDate
          this.card.endDate = this.endDate
          this.card.type = 1
          this.card.user = null
          this.card.head1 = null
          this.card.head2 = this.hideDetails
          this.card.head3 = null
          this.card.head4 = null
          this.card.head5 = null
          this.card.items = res ? res : []
          this.$store.dispatch('setPrintObj', this.card)
          if (typeReport === 1) {
            this.$refs.prnt.print()
          }
          if (typeReport === 2) {
            this.doXlsx()
          }
          const newTikTok = this.$store.state.tikTok + 1
          this.$store.dispatch('setTikTok', newTikTok)
        })
        .catch(err => {
          console.log('err', err)
        })
  
        this.showLocal = false
        
      //const haveResult = await freeCompensation(this.$store.state.companyid, this.startDate, this.endDate, 1, null)
      
    },
    // Rekapitulacija placa za razdoblje - sati, bruto 2, neto i neoporezivo po radniku.
    // The period is read from the JOPPD date of the obracun, so obracuni that have not
    // been sent or paid yet are in the report as well.
    async doRecap(typeReport) {
      try {
        if (!this.$store.state.companyid) {
          alert('Nije odabrana tvrtka.')
          return
        }
        const recap = await freeSalarieRecap(this.$store.state.companyid, this.startDate, this.endDate, this.selectEmp)
        if (!recap.employees.length) {
          // the dialog stays open so the period or the employee can be corrected right away
          alert(this.selectEmp
            ? 'Za odabranog radnika nema obračuna u odabranom razdoblju.'
            : 'Nema obračuna u odabranom razdoblju.')
          return
        }
        this.card = {}
        this.card.startDate = this.startDate
        this.card.endDate = this.endDate
        this.card.hideDetails = this.hideDetails
        this.card.showNotax = this.showNotax
        this.card.employeeName = this.recapEmployeeName()
        this.card.recap = recap
        this.$store.dispatch('setPrintObj', this.card)
        if (typeReport === 1) {
          this.$refs.prnt5.print()
        }
        if (typeReport === 2) {
          this.doRecapXlsx(recap)
        }
        const newTikTok = this.$store.state.tikTok + 1
        this.$store.dispatch('setTikTok', newTikTok)
        this.showLocal = false
      } catch (err) {
        // eslint-disable-next-line
        console.log('doRecap err', err)
      }
    },
    // Name of the picked employee, so the report can say it is for that one only.
    recapEmployeeName() {
      const emp = this.selectEmp
      if (!emp || !emp.id) { return '' }
      if (emp.employeeFullName) { return String(emp.employeeFullName).trim() }
      return ((emp.Last ? emp.Last + ' ' : '') + (emp.First ? emp.First : '')).trim()
    },
    // The same numbers as the pdf, one sheet, so the totals row can be checked in Excel.
    doRecapXlsx(recap) {
      if (!recap || !recap.employees || recap.employees.length === 0) {
        alert('Nema obračuna u odabranom razdoblju.')
        return
      }
      this.comp = this.$store.state.companyActiv ? this.$store.state.companyActiv : {}
      const lines = []
      const period = (this.startDate ? dayjs(this.startDate).format('DD.MM.YYYY') : '') + ' - ' + (this.endDate ? dayjs(this.endDate).format('DD.MM.YYYY') : '')

      lines.push({Radnik: this.comp.CompanyName ? this.comp.CompanyName : ''})
      lines.push({Radnik: 'OIB: ' + (this.comp.CompanyVATID ? this.comp.CompanyVATID : '')})
      lines.push({Radnik: 'Rekapitulacija plaća za razdoblje ' + period + ' (prema datumu JOPPD obrasca)'})
      const empName = this.recapEmployeeName()
      if (empName) { lines.push({Radnik: 'Radnik: ' + empName}) }
      lines.push({Radnik: 'Datum ispisa: ' + dayjs().format('DD.MM.YYYY HH:mm')})
      lines.push({})

      // Same order as the pdf - the employee with the totals first, the obracuni
      // they are made of underneath.
      let rbr = 0
      recap.employees.forEach(person => {
        rbr += 1
        lines.push({
          Rbr: rbr,
          Radnik: person.FullName,
          OIB: person.VatID,
          BrojJoppd: '',
          JoppdDatum: '',
          Sati: person.totals.hours,
          Bruto2: person.totals.bruto2,
          Neto: person.totals.neto,
          Neoporezivo: this.showNotax ? person.totals.notax : null,
          ZaIsplatu: this.showNotax ? person.totals.payout : null
        })
        if (!this.hideDetails) {
          person.lines.forEach(line => {
            lines.push({
              Rbr: '',
              Radnik: '   ' + (line.Month ? line.Month : '?') + '/' + (line.Year ? line.Year : '?') + (line.VrstaObracuna ? ' ' + line.VrstaObracuna : ''),
              OIB: '',
              BrojJoppd: line.BrojJoppd,
              JoppdDatum: line.JoppdDate ? dayjs(line.JoppdDate).format('DD.MM.YYYY') : '',
              Sati: line.hours,
              Bruto2: line.bruto2,
              Neto: line.neto,
              Neoporezivo: this.showNotax ? line.notax : null,
              ZaIsplatu: this.showNotax ? line.payout : null
            })
          })
        }
      })

      lines.push({
        Rbr: '',
        Radnik: 'SVEUKUPNO (' + recap.employees.length + ' radnika)',
        OIB: '',
        BrojJoppd: '',
        JoppdDatum: '',
        Sati: recap.totals.hours,
        Bruto2: recap.totals.bruto2,
        Neto: recap.totals.neto,
        Neoporezivo: this.showNotax ? recap.totals.notax : null,
        ZaIsplatu: this.showNotax ? recap.totals.payout : null
      })

      const columns = [
        {label: 'Rbr', value: 'Rbr'},
        {label: 'Radnik', value: 'Radnik'},
        {label: 'OIB', value: 'OIB'},
        {label: 'Broj JOPPD', value: 'BrojJoppd'},
        {label: 'Datum JOPPD', value: 'JoppdDatum'},
        {label: 'Ukupno sati', value: 'Sati', format: '#,##0.00'},
        {label: 'Bruto 2', value: 'Bruto2', format: '€#,##0.00'},
        {label: 'Neto (bez neoporezivog)', value: 'Neto', format: '€#,##0.00'}
      ]
      if (this.showNotax) {
        columns.push({label: 'Neoporezivo', value: 'Neoporezivo', format: '€#,##0.00'})
        columns.push({label: 'Za isplatu', value: 'ZaIsplatu', format: '€#,##0.00'})
      }

      const companyName = this.comp.CompanyNameDatabase ? this.comp.CompanyNameDatabase : ''
      const currDate = dayjs().format('DD_MM_YYYY_HH_mm')
      xlsx([{sheet: 'Rekapitulacija', columns: columns, content: lines}], {
        fileName: companyName + '_RekapitulacijaPlaca_' + currDate,
        extraLength: 3,
        writeOptions: {}
      })
    },
    async doAna(typeReport) {
      freeReport(this.$store.state.companyid, this.startDate, this.endDate, 1, this.selectEmp)
        .then(res => {
          const newObj = {}
          this.card = {...newObj}
          this.card.startDate = this.startDate
          this.card.endDate = this.endDate
          this.card.type = 1
          this.card.user = null
          this.card.head1 = null
          this.card.head2 = this.hideDetails
          this.card.head3 = null
          this.card.head4 = null
          this.card.head5 = null
          this.card.items = res ? res : []
          this.$store.dispatch('setPrintObj', this.card)
          if (typeReport === 1) {
            this.$refs.prnt2.print()
          }
          if (typeReport === 2) {
            this.$refs.prnt3.print()
          }
          if (typeReport === 2) {
            this.$refs.prnt4.print()
          }
          const newTikTok = this.$store.state.tikTok + 1
          this.$store.dispatch('setTikTok', newTikTok)
        })
        .catch(err => {
          console.log('err', err)
        })
  
        this.showLocal = false
        
      //const haveResult = await freeCompensation(this.$store.state.companyid, this.startDate, this.endDate, 1, null)
      
    },
    async doRAD1G(typeReport) {
      freeRAD1(this.$store.state.companyid, this.startDate, this.endDate, 1, this.selectEmp)
        .then(res => {
          const newObj = {}
          this.card = {...newObj}
          this.card.startDate = this.startDate
          this.card.endDate = this.endDate
          this.card.type = 1
          this.card.user = null
          this.card.head1 = null
          this.card.head2 = null
          this.card.head3 = null
          this.card.head4 = null
          this.card.head5 = null
          this.card.tables = res ? res : {}
          this.$store.dispatch('setPrintObj', this.card)
          if (typeReport === 1) {
            this.$refs.prnt4.print()
          }
          const newTikTok = this.$store.state.tikTok + 1
          this.$store.dispatch('setTikTok', newTikTok)
        })
        .catch(err => {
          console.log('err', err)
        })
  
        this.showLocal = false
        
      //const haveResult = await freeCompensation(this.$store.state.companyid, this.startDate, this.endDate, 1, null)
      
    },
    doXlsx() {
      this.comp = this.$store.state.companyActiv
      const persons = [...new Set(this.card.items.map(item => item.VatID))];

      const lines = []
      const f1 ={}
      f1.Opis = this.comp.CompanyNameShort
      lines.push(f1)
      const f2 ={}
      f2.Opis = this.comp.CompanyStreet + ' ' + this.comp.CompanyBuildingNameNumber
      lines.push(f2)
      const f3 ={}
      f3.Opis = this.comp.CompanyPostcode + ' ' + this.comp.CompanyCity
      lines.push(f3)
      const f4 ={}
      f4.Opis = 'OIB:' + this.comp.CompanyVATID  + (this.comp.Companyemail ? ', email:' +  this.comp.Companyemail: ' ') + ' Datum ispisa: ' + dayjs().format('DD.MM.YYYY, h:mm:ss a')
      lines.push(f4)

      const f5 ={}
      f5.Opis = 'Plaća - neoporezive isplate' 
      lines.push(f5)

      const f6 ={}
      f6.Opis = 'za period joppd od' + + (this.startDate ? dayjs(this.startDate).format('DD.MM.YYYY') + '/' : '') + (this.endDate ? dayjs(this.endDate).format('DD.MM.YYYY') : '')
      lines.push(f6)

      this.order = 0
      if (persons && persons.length > 0){
        persons.map(person => {
            const oneperson = this.card.items.filter(per => per.VatID === person)
            oneperson.sort(dynamicSortMultiple("value", 'JoppdDate'))
            this.order = 0
            let total = 0
            let totalBy = 0
            let cond = null

            if (oneperson && oneperson.length > 0){
              const f1 ={}
              f1.Radnik = '---------------------'
              lines.push(f1)
              const l ={}
              l.Opis = ''
              l.Radnik = (oneperson[0].First ? oneperson[0].First + ' ' : '') + (oneperson[0].Last ? oneperson[0].Last  : '')
              lines.push(l)
              
              oneperson.map(item=> {
                this.order += 1
                if (!cond) {
                  cond = item.value
                }
                if (cond !== item.value){
                  const haveIt = this.$store.state.joppdNotaxAll.find(tadd => (tadd.Value === cond) )
                  const avaY = haveIt && haveIt.OnYear && haveIt.OnYear > 0 ? haveIt.OnYear : null
                  const restY = avaY && haveIt.OnYear ? haveIt.OnYear - totalBy : null
                  const l ={}
                  l.Opis = ''
                  l.Order = ''
                  l.Radnik = 'Uk.'+(cond && haveIt && haveIt.Description ? haveIt.Description.substring(0, 90) : '')
                  l.vrsta = cond
                  l.BrojJoppd = item.BrojJoppd
                  l.JoppdPoslan = dayjs(item.JoppdPoslanDate ).format('DD.MM.YYYY') 
                  l.Iznos = totalBy
                  l.GodisnjeDozvoljeno = avaY
                  l.ZaIskoristiti = restY
                  lines.push(l)
                  totalBy = 0
                  cond = item.value
                }
                total += item.amount
                totalBy += item.amount
                this.totalAll += item.amount
                const l ={}
                l.Opis = ''
                l.Order = this.order
                l.Radnik = ''
                l.vrsta = item.value
                l.BrojJoppd = item.BrojJoppd
                l.JoppdPoslan = dayjs(item.JoppdPoslanDate ).format('DD.MM.YYYY') 
                l.Iznos = (item.amount)
                l.GodisnjeDozvoljeno = null
                l.ZaIskoristiti = null
                lines.push(l)
              })
            }
            // do final for person
            if (cond){
              const haveIt = this.$store.state.joppdNotaxAll.find(tadd => (tadd.Value === cond) )
              const avaY = haveIt && haveIt.OnYear && haveIt.OnYear > 0 ? haveIt.OnYear : null
              const restY = avaY && haveIt.OnYear ? haveIt.OnYear - totalBy : null
              const l ={}
              l.Opis = ''
              l.Order = ''
              l.Radnik = 'Uk.'+(cond && haveIt && haveIt.Description ? haveIt.Description.substring(0, 90) : '')
              l.vrsta = cond
              l.BrojJoppd = ''
              l.JoppdPoslan = ''
              l.Iznos = totalBy
              l.GodisnjeDozvoljeno = avaY
              l.ZaIskoristiti = restY
              lines.push(l)
            }
            const l ={}
            l.Opis = ''
            l.Order = ''
            l.Radnik = 'UKUPNO : ' + (oneperson[0].First ? oneperson[0].First + ' ' : '') + (oneperson[0].Last ? oneperson[0].Last  : '')
            l.Iznos = (total)
            lines.push(l)
            
        })
      }

      const f10 ={}
      f10.Radnik = '======================='
      lines.push(f10)
      const tt ={}
      tt.Opis = ''
      tt.Order = ''
      tt.Radnik = 'SVEUKUPNO : '
      tt.Iznos = (this.totalAll)
      lines.push(tt)
      console.log('lines', lines)

      const companyName = this.$store.state.companyActiv && this.$store.state.companyActiv.CompanyNameDatabase ? this.$store.state.companyActiv.CompanyNameDatabase : ''
      const currDate = dayjs().format('DD_MM_YYYY_HH_mm')
      const sheetNm = 'Neo_Isp_' + this.$store.state.businessYear + '_' + currDate
      let data = [
      {
        sheet: sheetNm,
        columns: [
          {label: 'Opis', value: 'Opis'},
          {label: 'Rbr', value: 'Order'},
          {label: 'Radnik', value: 'Radnik'},
          {label: 'Vrsta',value: 'vrsta' },
          {label: 'BrojJoppd' , value: 'BrojJoppd' },
          {label: 'Joppd Poslan', value: 'JoppdPoslan' },
          {label: 'Iznos', value: 'Iznos', format: "€#,##0.00"},
          {label: 'Godisnje Dozvoljeno' , value: 'GodisnjeDozvoljeno', format: "€#,##0.00" },
          {label: 'Za Iskoristiti' , value: 'ZaIskoristiti', format: "€#,##0.00" },

        ],
        content: lines
      },
    ]

      const settings = {
        fileName: companyName + '_NeoporeziveIsplate_' + currDate, // Name of the spreadsheet
        extraLength: 3, // A bigger number means that columns will be wider
        writeOptions: {} // Style options from https://github.com/SheetJS/sheetjs#writing-options
      }
      xlsx( data, settings)

    }
  },
  computed: {
  },
  watch: {
    // Picking a year sets the period to that whole year straight away. With a month
    // also picked the period narrows to that month, and clearing the month puts the
    // whole year back.
    'selectedYear' () {
      this.applyPeriod()
    },
    'selectedMonth' () {
      this.applyPeriod()
    }
  },
  components: {
    SalariePrintCompensation,
    SalariePrintRecap,
    SalariePrintReport,
    SalariePrintReportPotvrdaOPlaci,
    salarieprintreportrad1
  }

}

</script>